import { HAS_WINDOW } from './window.js';

/** Make sure updates of functionality also are copied to tokens/src/utils/flag */
let flags;
/**
 * This is a temporary clone of flags from lib/initial_options.ts in web. At some point
 * we should figure out a real way to get feature flags into fpl, probably via React context.
 * @deprecated Use `useFlag` or `useFlags` from FPL settings.
 */
function getFlags() {
    setFlags();
    return flags;
}
/**
 * This will only set flags ONCE if they exist. Once flags are populated, they won’t
 * update until the page is refreshed for performance.
 */
function setFlags() {
    // don’t keep creating flags if already set
    if (flags)
        return;
    if (HAS_WINDOW &&
        window.INITIAL_OPTIONS?.feature_flags &&
        typeof window.INITIAL_OPTIONS.feature_flags === 'object') {
        flags = Object.freeze({ ...window.INITIAL_OPTIONS.feature_flags });
    }
    else {
        flags = Object.freeze({});
    }
}

export { getFlags };
//# sourceMappingURL=flags.js.map
